import { load } from '@/router/routes/index';

export default [
    {
        path: 'calendar',
        component: load('calendar/CalendarIndex'),
        meta: { auth: true },
        children: [
            {
                path: '',
                name: 'calendar',
                component: load('calendar/EventIndex'),
                meta: { auth: true },
            },
            {
                path: 'events/create',
                name: 'event.create',
                props: true,
                component: load('calendar/EventCreate'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            {
                path: ':calendarId/events/:eventId/edit',
                name: 'event.edit',
                component: load('calendar/EventEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },
];
